import { useMemo } from "react";

import { FormInstance } from "antd/es/form/hooks/useForm";
import { RuleObject } from "rc-field-form/lib/interface";
import { IntlShape } from "react-intl";

import OptionValue from "@mapmycustomers/shared/types/customField/OptionValue";

import DefaultCustomFieldFormValues from "@app/scene/settings/component/CustomFields/type/DefaultCustomFieldFormValues";

export const useOptionValidationRules = (
  intl: IntlShape,
  form: FormInstance<DefaultCustomFieldFormValues>
) =>
  useMemo(
    () => [
      {
        message: intl.formatMessage({
          id: "settings.customFields.createEditPane.options.required.error",
          defaultMessage: "Option name is required.",
          description: "Settings Custom field - Validation message for required option",
        }),
        required: true,
      },
      {
        validator: (rule: RuleObject, value: string) => {
          const formattedValue = value.trim().toLowerCase();
          if (
            formattedValue !== "" &&
            (form.getFieldValue("options") as OptionValue[]).filter(
              ({ displayName }) => displayName.trim().toLowerCase() === formattedValue
            ).length > 1
          ) {
            return Promise.reject(
              intl.formatMessage({
                id: "settings.customFields.createEditPane.options.duplicate.error",
                defaultMessage: "Options cannot have same name",
                description: "Settings Custom field Validation message for duplicate options",
              })
            );
          }
          return Promise.resolve();
        },
      },
    ],
    [intl, form]
  );
